// extracted by mini-css-extract-plugin
export var arrow = "_c3-2";
export var label = "_c3-1";
export var reminder = "_c3-0";